
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"2 min read","minutes":1.02,"time":61200,"words":204}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The hand of gentry cards from which a player chooses guests and family to attend `}<a parentName="p" {...{
        "href": "activity"
      }}>{`activities`}</a>{`, provided she has both the reputation and servants to support them.`}</p>
    <div className="flavor-text">
      <p>{`The guests in a player’s Active Hand comprise those acquaintances in the family’s circle of friends who should next be invited to visit. Propriety required that friends not be neglected, and the Active Hand reflects those connections who are perhaps overdue to attend an appropriate social occasion at the estate.`}</p>
    </div>
    <p>{`A player’s gentry card deck is composed of an Active Hand and a face-up discard pile. The Active Hand contains those family members and guests from whom the player must choose when issuing invitations to attend an `}<a parentName="p" {...{
        "href": "activity"
      }}>{`activity`}</a>{`. Once a family member or guest attends an `}<a parentName="p" {...{
        "href": "activity"
      }}>{`activity`}</a>{`, that card is placed in the player’s discard pile and is not available again until that player passes and reclaims her deck. If a player does not have sufficient qualifying guests to attend one of the `}<a parentName="p" {...{
        "href": "activity"
      }}>{`activities`}</a>{` listed on a tile in her country estate organiser, she must pass or choose to hire servants by playing the butler’s room (which is the lone “playable” tile that does not require a gentry card).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Active Hand"
}

